$(document).ready(function() {
    void 0 !== $('form[id*="webformportlet"]').val() && $(".alert.alert-error").each(function(t) {
        var a = $(this).parent();
        a.addClass("addMargin");
        var e = $(this).parent().next(".control-group");
        a.detach(),
        e.after(a);
        var n = e.find("label.col-form-label");
        if ("" != n.text())
            n.html(n.text() + " <span class='star'>*</span>");
        else {
            var r = e.find("input[type='checkbox'].field:not('.optional')").parent().html();
            e.find("input[type='checkbox'].field:not('.optional')").parent().html(r + " <span class='star'>*</span>")
        }
    })
});
